import type { TvReceiverCommand, TvRequestedCommand } from './protocol';
import { db, functions } from './firebase';
import type { StoredTvDevice } from './tvDevice';
import { unwrapNestedArrays } from './nestedArrays';
import { TV_SOUND_CAPABILITY } from '../../../packages/putt-scene/src/sound';
import {
  callableErrorCode,
  createTvReceiverClient,
  HEARTBEAT_INTERVAL_MS,
  RECEIVER_CAPABILITIES,
  type TvReceiverConnection,
} from './tvSessionClient';
export { unwrapNestedArrays, callableErrorCode, HEARTBEAT_INTERVAL_MS, RECEIVER_CAPABILITIES };
export type { TvReceiverConnection };

export const RECEIVER_NAME = 'LagKing TV';

/** The page also plays the sound effects (sfx.ts). The shared default list
 *  stays without it: the Apple TV app adds it itself, and only once its audio
 *  has started (web/tv/appletv/src/sfxService.ts), so a phone paired with an
 *  Apple TV whose audio failed keeps playing sound itself. */
export const PAGE_RECEIVER_CAPABILITIES = [...RECEIVER_CAPABILITIES, TV_SOUND_CAPABILITY];

// The page's receiver: its own Firebase app (firebase.ts) and name. The
// session logic lives in tvSessionClient.ts, shared with the Apple TV app.
const client = createTvReceiverClient({
  db,
  functions,
  receiverName: RECEIVER_NAME,
  receiverCapabilities: PAGE_RECEIVER_CAPABILITIES,
});

/** A TV with no stored token: open a session that shows a pairing code. */
export function createReceiver(): Promise<TvReceiverConnection> {
  return client.createReceiver();
}

/** A TV the account already knows: open a session bound to its device. */
export function resumeReceiver(device: StoredTvDevice): Promise<TvReceiverConnection> {
  return client.resumeReceiver(device);
}

/**
 * Kept for a remote-bearing TV app (TV_REVIVAL_PLAN.md §1.4). The web page
 * has no controls and never calls this.
 */
export function sendReceiverCommand(
  target: { sessionId: string; receiverSecret: string },
  command: TvRequestedCommand,
): Promise<TvReceiverCommand> {
  return client.sendReceiverCommand(target, command);
}
